/* eslint-disable no-shadow */
import { helpers } from '@vuelidate/validators';
import XRegExp from 'xregexp-new/lib/index';

export const usePattern = () => {
	const pattern = (patt) => (value) => {
		if (!helpers.req(value)) {
			return true;
		}
		let match = false;
		if (Array.isArray(patt)) {
			for (let regex of patt) {
				const reg = new XRegExp(regex);
				match = match || reg.test(value);
			}
		} else {
			let reg = new XRegExp(patt);
			match = reg.test(value);
		}
		return match;
	};
	return {
		pattern
	};
};
